<script>
export default {
    name: 'ModalYesNo',
}
</script>


<template>
    <div class="mainFooter" v-on:keyup.enter="$emit('yes')" v-on:keyup.escape="$emit('no')">
        <input type="button" class="btn" v-on:click="$emit('yes')" value="Valider" />
        <input type="button" class="btn" v-on:click="$emit('no')"  value="Annuler" />
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.mainFooter{
    margin: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 70%;
    margin-top: 5px;
}

.btn{
    @include myButton;
}

</style>